import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { JobQueryParams } from "@/types";

export function useExportJobTracker() {
  return useMutation({
    mutationFn: async (queryParams: JobQueryParams) => {
      await guacHttpClient.post("exports/job-tracker", queryParams);
    },
  });
}
